const OwalPanelType = {
  INPUT: 1,
  REVIEW: 2,
  DISPLAY: 3,
  properties: {
    1: { description: 'input' },
    2: { description: 'review' },
    3: { description: 'display' },
  },
}

if (Object.freeze) {
  Object.freeze(OwalPanelType)
}

export { OwalPanelType }
